// extracted by mini-css-extract-plugin
export var redoItem = "_kc-1";
export var redoTrigger = "_kc-0";